var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { create } from 'apisauce';
import authStorage from '../auth/storage';
import auth from '../auth/auth';
const apiClient = create({
    baseURL: '/',
});
apiClient.addAsyncRequestTransform((request) => __awaiter(void 0, void 0, void 0, function* () {
    if (!request.headers)
        request.headers = {};
    request.headers['secret'] = process.env.SYSTEM_SECRET_KEY || '';
    const token = authStorage.getToken();
    if (!token)
        return;
    request.headers[authStorage.key] = token;
}));
apiClient.addResponseTransform((response) => {
    var _a;
    if (response.status === 401 && ((_a = response.config) === null || _a === void 0 ? void 0 : _a.url) !== '/api/auth/check') {
        auth.logout();
    }
});
export default apiClient;
